import './OnboardingInputs.css';
import React, { useState } from 'react';

import {
  extractFacebookUsername,
  extractInstagramUsername,
  extractTikTokUsername,
  extractLinkedInProfile,
  extractWhatsAppNumber,
  extractTwitterUsername,
  extractYelpBusinessID,
  extractGoogleReviewsPlaceID
} from '../utils/SocialRegex'; // Adjust the import path as needed


const SocialMediaSelector = ({ onSocialMediaSelect, selectedSocialMedia, languageSetting }) => {
  var socialMediaOptions = {
    FACEBOOK: { name: languageSetting === "ENGLISH" ? 'Facebook' : 'Facebook', prompt: languageSetting === "ENGLISH" ? 'Enter Your Facebook Profile URL or Username' : 'Ingresa Tu URL De Perfil De Facebook O Nombre De Usuario' },
    INSTAGRAM: { name: languageSetting === "ENGLISH" ? 'Instagram' : 'Instagram', prompt: languageSetting === "ENGLISH" ? 'Enter Your Instagram Profile URL or Handle' : 'Ingresa Tu URL De Perfil De Instagram O Manejo' },
    TIKTOK: { name: languageSetting === "ENGLISH" ? 'TikTok' : 'TikTok', prompt: languageSetting === "ENGLISH" ? 'Enter Your TikTok Profile URL or Handle' : 'Ingresa Tu URL De Perfil De TikTok O Manejo' },
    LINKEDIN: { name: languageSetting === "ENGLISH" ? 'LinkedIn' : 'LinkedIn', prompt: languageSetting === "ENGLISH" ? 'Enter Your LinkedIn Profile URL or Username' : 'Ingresa Tu URL De Perfil De LinkedIn O Nombre De Usuario' },
    WHATSAPP: { name: languageSetting === "ENGLISH" ? 'WhatsApp' : 'WhatsApp', prompt: languageSetting === "ENGLISH" ? 'Enter Your WhatsApp Phone Number or Link' : 'Ingresa Tu Número De Teléfono De WhatsApp O Enlace' },
    TWITTER: { name: languageSetting === "ENGLISH" ? 'Twitter' : 'Twitter', prompt: languageSetting === "ENGLISH" ? 'Enter Your Twitter Profile URL or Handle' : 'Ingresa Tu URL De Perfil De Twitter O Manejo' },
    YELP: { name: languageSetting === "ENGLISH" ? 'Yelp' : 'Yelp', prompt: languageSetting === "ENGLISH" ? 'Enter Your Yelp Business Profile URL or Yelp Business Name' : 'Ingresa Tu URL De Perfil De Yelp O Nombre De Negocio De Yelp' },
    GOOGLE_REVIEWS: { name: languageSetting === "ENGLISH" ? 'Google Reviews' : 'Google Reviews', prompt: languageSetting === "ENGLISH" ? 'Enter Your Google Reviews Profile URL' : 'Ingresa Tu URL De Perfil De Google Reviews' }
    // Add more social media options here
  };

  const [socialMediaError, setSocialMediaError] = useState({
    FACEBOOK: '',
    INSTAGRAM: '',
    TIKTOK: '',
    LINKEDIN: '',
    WHATSAPP: '',
    TWITTER: '',
    YELP: '',
    GOOGLE_REVIEWS: ''
    // Add more social media options here
  });

  const newSocialMedia = Object.keys(socialMediaOptions).map((x) => ({
    name: socialMediaOptions[x].name,
    id: x,
    showInput: selectedSocialMedia[x] ? selectedSocialMedia[x].showInput : false,
    value: selectedSocialMedia[x] ? selectedSocialMedia[x].value : '',
    prompt: socialMediaOptions[x].prompt
  }));

  const handleDivClick = (option) => { 
    if(newSocialMedia[option].showInput){newSocialMedia[option].value=''}
    newSocialMedia[option].showInput = !newSocialMedia[option].showInput; 
    onSocialMediaSelect(newSocialMedia[option]); 
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    const newSocial = selectedSocialMedia[event.target.dataset.socialName];
    newSocial['value'] = value;
    onSocialMediaSelect(newSocial);
  };

  // New handleBlur function to trigger validation
  const handleInputBlur = (event) => {
    const value = event.target.value;
    const socialType = event.target.dataset.socialName;

    const this_social = newSocialMedia.filter(x => x['id'] === socialType);
    const option = this_social[0];
    const option_id = option['id'];
    let option_val;

    if (option_id === 'FACEBOOK') {
        option_val = extractFacebookUsername(option['value']);
    } else if (option_id === 'INSTAGRAM') {
        option_val = extractInstagramUsername(option['value']);
    } else if (option_id === 'TIKTOK') {
        option_val = extractTikTokUsername(option['value']);
    } else if (option_id === 'LINKEDIN') {
        option_val = extractLinkedInProfile(option['value']);
    } else if (option_id === 'WHATSAPP') {
        option_val = extractWhatsAppNumber(option['value']);
    } else if (option_id === 'TWITTER') {
        option_val = extractTwitterUsername(option['value']);
    } else if (option_id === 'YELP') {
        option_val = extractYelpBusinessID(option['value']);
    } else if (option_id === 'GOOGLE_REVIEWS') {
        option_val = extractGoogleReviewsPlaceID(option['value']);
    }

    // Update the option with the extracted value
    option['value'] = option_val['return_string'];
    
    // Set any errors based on the validator's response
    setSocialMediaError((socialMediaError) => ({
        ...socialMediaError,
        [option_id]: option_val['error']
    }));

    // Trigger the callback to handle the validated option
    onSocialMediaSelect(option);

  };

  return (
    <div className="container">
      {Object.keys(newSocialMedia).map((option) => (
        <div key={option} className="option-container">
          <div
            onClick={() => handleDivClick(option)}
            className="option-button"
          >
            {newSocialMedia[option].name} {newSocialMedia[option].showInput}
          </div>
          {newSocialMedia[option].showInput && (
            <div className="input-container">
              <p className="help-text">{newSocialMedia[option].prompt}</p>
              <input
                type="text"
                value={newSocialMedia[option].value}
                onChange={(event) => handleInputChange(event)}
                onBlur={(event) => handleInputBlur(event)}
                className="input-field"
                data-social-name={newSocialMedia[option].id}
              />
              <p className="error-text">{socialMediaError[newSocialMedia[option].id]}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SocialMediaSelector;
